import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../../typings'

interface Payload {
  id: string
  mode: 'on' | 'off'
}

/**
 * Create a new Driver.
 *
 * @private
 */
export const setCustomRouteStyle = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/mapStyles/setCustomRouteStyle', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/mapStyles/setCustomRouteStyle', {
      type: 'rpc/ui/mapStyles/setCustomRouteStyle',
      category: 'rpc',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        error: result,
        type: 'rpcFailure',
        message: result.errorMessage,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {setCustomRouteStyle}`,
      { tags: ['rpc', 'ui', 'map', 'mapStyles'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      error,
      type: 'unknown',
      message: `Failed to update a Route Map Style`,
    })
  }
})
